var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m3.333 7.4 1.334-1.333 3.666 3.667L10.667 7.4l2 2V3.333H3.333zM2.667 2h10.666c.368 0 .667.298.667.667v10.666a.667.667 0 0 1-.667.667H2.667A.667.667 0 0 1 2 13.333V2.667C2 2.298 2.298 2 2.667 2m7.666 4.667a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
})));
export { SvgImageIcon as ReactComponent };
export default __webpack_public_path__ + "e3cdd4750a882654e10e9a3fd2a71ecb.svg";